export const classes = {
  legend: 'flex gap-3.5 text-[11.5px] text-taupe-2',
  item: 'place-start gap-1.5',
  swatch: 'size-[9px] rounded-[3px]',
  line: 'w-[13px] h-[3px] rounded-[2px]',
};

export const styles = {
  swatch: (color: string) => ({ backgroundColor: color }),
};
